import { MAP_DEVICE_PIXEL_RATIO } from "../../../configs";

export const COMMON_OPTIONS = {
  devicePixelRatio: MAP_DEVICE_PIXEL_RATIO,
  responsive: true,
  maintainAspectRatio: false,
  minRotation: 0,
  plugins: {
    title: {
      display: false
    },
    legend: {
      display: false
    },
    tooltip: {
      enabled: false
    },
    datalabels: {
      display: false
    }
  }
};

export const COLORS = {
  COLOR_1 : 'rgba(0, 0, 0, 0.6)',
  COLOR_2 : 'rgba(152, 207, 255 ,0.6)',
  COLOR_3 : 'rgba(0, 208, 255, 0.6)',
  COLOR_4 : 'rgba(0, 165, 255, 0.6)',
  COLOR_5 : 'rgba(1, 165, 255, 0.6)',
  COLOR_6 : 'rgba(3, 112, 207, 0.6)',
  COLOR_7 : 'rgba(0, 56, 148, 0.6)',
  COLOR_8 : 'rgba(0, 45, 118, 0.6)',
  COLOR_9 : 'rgba(0, 34, 89 , 0.6)',
  COLOR_10 : 'rgba(0, 22, 59, 0.6)',
}
